<h2 class="sr-only">{{ "EreidSuche" | translate }}</h2>
<form (ngSubmit)="onSubmit()" [meta]="ereidRequest" #form="ngForm">
  <cap-form-row column-classes="col-md-2,col-md-3">
    <cap-form-control invalidKey="EingabeMussValideEreidSein" labelKey="EREID">
      <input
        (ngModelChange)="ereidRequest && ereidRequest.ereid && (ereidRequest.ereid.value = $event)"
        [ngModel]="ereidRequest && ereidRequest.ereid?.value"
        #ereidTemplate
        autofocus
        id="ereid"
        name="ereid"
        required
        type="text" />
    </cap-form-control>
  </cap-form-row>

  <div class="row mt-4">
    <div class="col-3">
      <cap-history-options
        (ngModelChange)="ereidRequest && (ereidRequest.historySearchOptions = $event)"
        [ngModel]="ereidRequest && ereidRequest.historySearchOptions"
        name="historySearchOptions"></cap-history-options>
    </div>
  </div>
  <div class="p-2" id="actionpane">
    <div class="rechtsbuendig">
      <button (click)="onReset()" class="btn btn-outline-primary btn-actionpane" type="button">{{ "Zurücksetzen" | translate }}</button>
      <button [disabled]="!form.form.valid" class="btn btn-primary btn-actionpane" type="submit">{{ "Suche" | translate }}</button>
    </div>
  </div>
</form>
